var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.children),function(child,index){return _c('div',{key:index,staticClass:"message-card"},[_c('v-card',{class:[child.crm_id ? 'crm-card' : 'user-card', 'card-show'],attrs:{"width":"45vw"}},[_c('v-card-text',[_vm._v(" "+_vm._s(child.content)+" ")])],1),_c('TicketComponent',{attrs:{"children":child.children_recursive}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }